var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.id
    ? _c("div", {}, [
        _c("section", { staticClass: "video-player" }, [
          _c("div", { staticClass: "container" }, [
            _vm.isAllowed === true && _vm.testqsActive && !_vm.testqsSkip
              ? _c(
                  "div",
                  { staticClass: "quest-container maxhd" },
                  [
                    _c("testqs-overlay", {
                      attrs: {
                        item: _vm.item,
                        group: _vm.testqsActive,
                        index: _vm.testqsIndex
                      },
                      on: {
                        close: _vm.closeTest,
                        again: _vm.tryAgain,
                        close2: function($event) {
                          _vm.testqsSkip = true
                          _vm.testqsActive = null
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.videoUrl || _vm.introPhotoUrl) && _vm.isAllowed === true
              ? _c(
                  "div",
                  { staticClass: "top-video-container maxhd" },
                  [
                    _vm.videoUrl
                      ? _c("videoplayer", {
                          attrs: {
                            src: _vm.videoUrl,
                            poster: _vm.posterUrl,
                            loop: _vm.item.type && _vm.item.type.id == 5,
                            chapters: _vm.item.chapters,
                            paused: !!_vm.testqsActive || _vm.testqsSkip,
                            introVideo: _vm.introVideo,
                            outroVideo: _vm.outroVideo
                          },
                          on: { duration: _vm.setDuration, seek: _vm.setTime }
                        })
                      : _vm.introPhotoUrl
                      ? _c("div", { staticClass: "tv-inner" }, [
                          _c("div", { staticClass: "video-container" }, [
                            _c("img", { attrs: { src: _vm.introPhotoUrl } }),
                            _vm._v(" "),
                            _vm.isIndependent && _vm.isAllowed
                              ? _c("div", { staticClass: "quest" }, [
                                  !_vm.isIndependentDone
                                    ? _c("span", { staticClass: "stat" }, [
                                        _vm._v("Pending")
                                      ])
                                    : _c("span", { staticClass: "stat" }, [
                                        _vm._v("Completed")
                                      ]),
                                  _vm._v(" "),
                                  _c("h2", [_vm._v("Questionare")]),
                                  _vm._v(" "),
                                  !_vm.isIndependentDone
                                    ? _c("p", [
                                        _vm._v(
                                          "You haven’t completed our questionnaire yet, please do it by clicking on the start button."
                                        )
                                      ])
                                    : _c("p", [
                                        _vm._v(
                                          "You have completed this questionnaire."
                                        )
                                      ]),
                                  _vm._v(" "),
                                  !_vm.isIndependentDone
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "qbtn",
                                          attrs: { href: "" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              _vm.testqsActive =
                                                _vm.item.testqs.independent
                                              _vm.testqsIndex = 0
                                              _vm.testqsSkip = false
                                            }
                                          }
                                        },
                                        [_vm._v("Start")]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            (_vm.videoUrl || _vm.introPhotoUrl) && _vm.isAllowed === false
              ? _c(
                  "div",
                  { staticClass: "top-video-container maxhd" },
                  [
                    _c("div", { staticClass: "tv-inner" }, [
                      _c("div", { staticClass: "video-container" }, [
                        _c("img", {
                          staticClass: "blurred",
                          attrs: { src: _vm.posterUrl || _vm.introPhotoUrl }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("group-details-vid", {
                      attrs: {
                        group: _vm.item.group && _vm.item.group.id,
                        video2: _vm.item,
                        video: _vm.item.parent ? _vm.item.parent : _vm.item,
                        noPpatt: _vm.isVideoPpatt && !_vm.isUserPpatt
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "page-content" }, [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "pg-main text-content" },
              [
                _c("h1", [
                  _vm._v(
                    _vm._s(
                      _vm.item.parent
                        ? _vm.item.parent.subtitle
                        : _vm.item.subtitle
                    ) +
                      " " +
                      _vm._s(_vm.item.title)
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.item.blocks, function(block, bi) {
                  return [
                    block.type == "intro"
                      ? _c("div", {
                          staticClass: "intro",
                          domProps: { innerHTML: _vm._s(block.content) }
                        })
                      : block.type == "text"
                      ? _c("div", {
                          staticClass: "post-text",
                          domProps: { innerHTML: _vm._s(block.content) }
                        })
                      : block.type == "image"
                      ? _c(
                          "div",
                          {
                            staticClass: "post-full-img",
                            class: {
                              pfileft: block.prefix == "left",
                              pfiright: block.prefix == "right"
                            }
                          },
                          [
                            _vm.isPhoto(block.media)
                              ? _c("img", {
                                  attrs: { src: _vm.photoLink(block.media) }
                                })
                              : _vm.isAllowed === true || _vm.isExpired === true
                              ? _c("div", { staticClass: "ext-link" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href: _vm.photoLink(block.media)
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Download: " +
                                          _vm._s(_vm.fileName(block.media))
                                      )
                                    ]
                                  )
                                ])
                              : _c("div", { staticClass: "ext-link" }, [
                                  _c("a", [
                                    _vm._v(
                                      "Download: " +
                                        _vm._s(_vm.fileName(block.media))
                                    )
                                  ])
                                ])
                          ]
                        )
                      : block.type == "h2"
                      ? _c("h2", [_vm._v(_vm._s(block.content))])
                      : block.type == "blockquote"
                      ? _c("blockquote", [
                          _vm._m(0, true),
                          _vm._v(" "),
                          _vm.hasText(block.prefix)
                            ? _c("div", {
                                staticClass: "title",
                                domProps: { innerHTML: _vm._s(block.prefix) }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            domProps: { innerHTML: _vm._s(block.content) }
                          }),
                          _vm._v(" "),
                          _vm.hasText(block.suffix)
                            ? _c("div", {
                                staticClass: "signature",
                                domProps: { innerHTML: _vm._s(block.suffix) }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(1, true)
                        ])
                      : _vm._e()
                  ]
                }),
                _vm._v(" "),
                _c("edit-tags", { attrs: { edit: false, item: _vm.item } })
              ],
              2
            ),
            _vm._v(" "),
            _c("aside", [
              _c(
                "div",
                { staticClass: "vprop" },
                [
                  _c("date", [
                    _vm._v(
                      _vm._s(_vm.formatDate(_vm.item.created, "MMM Do, YYYY"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "cat" }, [
                    _vm._v(_vm._s(_vm.item.type && _vm.item.type.title))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vact" },
                [
                  _c("share"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "fav",
                      class: { active: _vm.existingLike },
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggleLike($event)
                        }
                      }
                    },
                    [_vm._v("Favourite")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              false && _vm.isIndependent && _vm.isAllowed
                ? _c("div", { staticClass: "quest" }, [
                    !_vm.isIndependentDone
                      ? _c("span", { staticClass: "stat" }, [_vm._v("Pending")])
                      : _c("span", { staticClass: "stat" }, [
                          _vm._v("Completed")
                        ]),
                    _vm._v(" "),
                    _c("h2", [_vm._v("Questionare")]),
                    _vm._v(" "),
                    !_vm.isIndependentDone
                      ? _c("p", [
                          _vm._v(
                            "You haven’t completed our questionnaire yet, please do it by clicking on the start button."
                          )
                        ])
                      : _c("p", [
                          _vm._v("You have completed this questionnaire.")
                        ]),
                    _vm._v(" "),
                    !_vm.isIndependentDone
                      ? _c(
                          "a",
                          {
                            staticClass: "qbtn",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.testqsActive = _vm.item.testqs.independent
                                _vm.testqsIndex = 0
                                _vm.testqsSkip = false
                              }
                            }
                          },
                          [_vm._v("Start")]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.allVideos && _vm.item.allVideos.length
                ? _c("div", { staticClass: "videos-list" }, [
                    _c("h3", [
                      _c("label", [_vm._v("Content in:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.item.parent
                              ? _vm.item.parent.subtitle
                              : _vm.item.subtitle
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.item.allVideos, function(relVideo) {
                        return _c(
                          "li",
                          { class: { active: _vm.item.id == relVideo.id } },
                          [
                            _c("img", {
                              attrs: { src: _vm.itemPoster(relVideo) }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "details" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "content",
                                        params: { id: relVideo.id }
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(relVideo.title))]
                                ),
                                _vm._v(" "),
                                _c("date", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(
                                        relVideo.created,
                                        "MMM Do, YYYY"
                                      )
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        false
          ? _c("section", { staticClass: "gen-list" }, [
              _c("div", { staticClass: "container" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("ul", { staticClass: "gen-list-content" }, [
                  _c("li", { staticClass: "vid" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "desc" },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus."
                          )
                        ]),
                        _vm._v(" "),
                        _c("date", [_vm._v("Jan 13th, 2021")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a", { staticClass: "wlink", attrs: { href: "" } })
                  ]),
                  _vm._v(" "),
                  _c("li", {}, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "desc" },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus."
                          )
                        ]),
                        _vm._v(" "),
                        _c("date", [_vm._v("Jan 13th, 2021")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a", { staticClass: "wlink", attrs: { href: "" } })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "vid" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "desc" },
                      [
                        _vm._m(8),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus."
                          )
                        ]),
                        _vm._v(" "),
                        _c("date", [_vm._v("Jan 13th, 2021")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a", { staticClass: "wlink", attrs: { href: "" } })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "vid" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "desc" },
                      [
                        _vm._m(10),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus."
                          )
                        ]),
                        _vm._v(" "),
                        _c("date", [_vm._v("Jan 13th, 2021")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a", { staticClass: "wlink", attrs: { href: "" } })
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        false
          ? _c("div", { staticClass: "seg-content page" }, [
              _c("div", { staticClass: "post-container" }, [
                _c("div", { staticClass: "post-head" }, [
                  _c("div", { staticClass: "ph-split" }, [
                    _c("div", { staticClass: "type" }, [
                      _vm.item.type ? _c("span", [_c("i")]) : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "group",
                        staticStyle: { "max-width": "230px" }
                      },
                      [
                        _vm.item.group
                          ? _c(
                              "span",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "group",
                                        params: { group: _vm.item.group.id }
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.item.group.title))]
                                )
                              ],
                              1
                            )
                          : _c("span")
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "post-tools" }, [
                      _c("ul", [
                        _vm.item.hasComments
                          ? _c("li", { staticClass: "comments" }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.goComments($event)
                                    }
                                  }
                                },
                                [_vm._v("Go to comments")]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.item.comments.length))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "likes" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toggleLike($event)
                                }
                              }
                            },
                            [_vm._v("Like")]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.item.likes))])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ph-split" }, [
                    _c("div", [
                      _c("h1"),
                      _vm._v(" "),
                      _vm.item.subtitle
                        ? _c("h2", { staticClass: "subtitle" }, [
                            _vm._v(_vm._s(_vm.item.subtitle))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.item.author
                      ? _c("div", { staticClass: "auth" }, [
                          _c(
                            "div",
                            { staticClass: "auth-img" },
                            [
                              _c("i"),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "content.teacher",
                                      params: { id: _vm.item.author.username }
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.photoLinkR(
                                        _vm.item.author.media,
                                        256,
                                        256,
                                        "Fit"
                                      )
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(_vm.item.author.pubname))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "role" }, [
                              _vm._v(_vm._s(_vm.item.author.title))
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "post-content" },
                  [
                    _vm._l(_vm.item.blocks, function(block, bi) {
                      return [
                        block.type == "intro"
                          ? _c("div", {
                              staticClass: "intro",
                              domProps: { innerHTML: _vm._s(block.content) }
                            })
                          : block.type == "text"
                          ? _c("div", {
                              staticClass: "post-text",
                              domProps: { innerHTML: _vm._s(block.content) }
                            })
                          : block.type == "image"
                          ? _c(
                              "div",
                              {
                                staticClass: "post-full-img",
                                class: {
                                  pfileft: block.prefix == "left",
                                  pfiright: block.prefix == "right"
                                }
                              },
                              [
                                _vm.isPhoto(block.media)
                                  ? _c("img", {
                                      attrs: { src: _vm.photoLink(block.media) }
                                    })
                                  : _vm.isAllowed === true ||
                                    _vm.isExpired === true
                                  ? _c("div", { staticClass: "ext-link" }, [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.photoLink(block.media)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Download: " +
                                              _vm._s(_vm.fileName(block.media))
                                          )
                                        ]
                                      )
                                    ])
                                  : _c("div", { staticClass: "ext-link" }, [
                                      _c("a", [
                                        _vm._v(
                                          "Download: " +
                                            _vm._s(_vm.fileName(block.media))
                                        )
                                      ])
                                    ])
                              ]
                            )
                          : block.type == "h2"
                          ? _c("h2", [_vm._v(_vm._s(block.content))])
                          : block.type == "blockquote"
                          ? _c("blockquote", [
                              _vm._m(11, true),
                              _vm._v(" "),
                              _vm.hasText(block.prefix)
                                ? _c("div", {
                                    staticClass: "title",
                                    domProps: {
                                      innerHTML: _vm._s(block.prefix)
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", {
                                domProps: { innerHTML: _vm._s(block.content) }
                              }),
                              _vm._v(" "),
                              _vm.hasText(block.suffix)
                                ? _c("div", {
                                    staticClass: "signature",
                                    domProps: {
                                      innerHTML: _vm._s(block.suffix)
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._m(12, true)
                            ])
                          : _vm._e()
                      ]
                    }),
                    _vm._v(" "),
                    _c("edit-tags", { attrs: { edit: false, item: _vm.item } })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.item.hasComments
                  ? _c(
                      "div",
                      { ref: "comments", staticClass: "post-comments" },
                      [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.formatPlural(
                                _vm.item.comments.length,
                                "comment"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          [
                            _vm._l(_vm.item.comments, function(comment, ci) {
                              return [
                                comment.parent == null
                                  ? _c("li", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "type",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.openReply(ci)
                                            }
                                          }
                                        },
                                        [_vm._v("Reply")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "author" }, [
                                        comment.author
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  comment.author.firstname +
                                                    " " +
                                                    comment.author.lastname
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      comment.author && comment.author.media
                                        ? _c(
                                            "div",
                                            { staticClass: "auth-img" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.photoLink(
                                                    comment.author.media
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "comment-text",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.escapeText(comment.content)
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("time", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(
                                              comment.created,
                                              "MMM Do, YYYY [at] h:mm a"
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.item.comments, function(
                                  comment2,
                                  ci2
                                ) {
                                  return comment2.parent == comment.id
                                    ? _c("li", { staticClass: "reply" }, [
                                        _c("div", { staticClass: "author" }, [
                                          comment2.author
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    comment2.author.firstname +
                                                      " " +
                                                      comment2.author.lastname
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        comment2.author && comment2.author.media
                                          ? _c(
                                              "div",
                                              { staticClass: "auth-img" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.photoLink(
                                                      comment2.author.media
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "comment-text",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.escapeText(comment2.content)
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("time", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(
                                                comment2.created,
                                                "MMM Do, YYYY [at] h:mm a"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm.replyId == comment.id && _vm.currentUser
                                  ? _c("li", { staticClass: "form reply" }, [
                                      _c("div", { staticClass: "type" }, [
                                        _vm._v("Leave a Reply")
                                      ]),
                                      _vm._v(" "),
                                      _vm.currentUser.media
                                        ? _c(
                                            "div",
                                            { staticClass: "auth-img" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.photoLink(
                                                    _vm.currentUser.media
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "form",
                                        {
                                          on: {
                                            submit: function($event) {
                                              $event.preventDefault()
                                              return _vm.submitReply($event)
                                            }
                                          }
                                        },
                                        [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.replyComment,
                                                expression: "replyComment"
                                              }
                                            ],
                                            ref: "replyBox",
                                            refInFor: true,
                                            domProps: {
                                              value: _vm.replyComment
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.replyComment =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("button", [_vm._v("Send")])
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            }),
                            _vm._v(" "),
                            _vm.currentUser
                              ? _c("li", { staticClass: "form" }, [
                                  _c("div", { staticClass: "type" }, [
                                    _vm._v("Leave a Comment")
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentUser.media
                                    ? _c("div", { staticClass: "auth-img" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.photoLink(
                                              _vm.currentUser.media
                                            )
                                          }
                                        })
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                          return _vm.submitComment($event)
                                        }
                                      }
                                    },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.newComment,
                                            expression: "newComment"
                                          }
                                        ],
                                        ref: "commentBox",
                                        domProps: { value: _vm.newComment },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.newComment = $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("button", [_vm._v("Send")])
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "before" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "after" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gs-head" }, [
      _c("h2", [_vm._v("Related Videos")]),
      _vm._v(" "),
      _c("a", { staticClass: "lnk-list", attrs: { href: "" } }, [
        _vm._v("see all")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preview" }, [
      _c("img", { attrs: { src: "temp/list1.jpg" } }),
      _vm._v(" "),
      _c("span", { staticClass: "video" }),
      _vm._v(" "),
      _c("span", { staticClass: "cat" }, [_vm._v("Workshop")]),
      _vm._v(" "),
      _c("span", { staticClass: "stat active" }, [_vm._v("Jul 17th 2021")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("a", { attrs: { href: "" } }, [
        _vm._v("Sample video title to test long video names")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preview" }, [
      _c("img", { attrs: { src: "temp/list1.jpg" } }),
      _vm._v(" "),
      _c("span", { staticClass: "video" }),
      _vm._v(" "),
      _c("span", { staticClass: "cat" }, [_vm._v("Workshop")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("a", { attrs: { href: "" } }, [
        _vm._v("Sample video title to test long video names")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preview" }, [
      _c("img", { attrs: { src: "temp/list1.jpg" } }),
      _vm._v(" "),
      _c("span", { staticClass: "video" }),
      _vm._v(" "),
      _c("span", { staticClass: "cat" }, [_vm._v("Workshop")]),
      _vm._v(" "),
      _c("span", { staticClass: "stat locked" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("a", { attrs: { href: "" } }, [
        _vm._v("Sample video title to test long video names")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preview" }, [
      _c("img", { attrs: { src: "temp/list1.jpg" } }),
      _vm._v(" "),
      _c("span", { staticClass: "video" }),
      _vm._v(" "),
      _c("span", { staticClass: "cat" }, [_vm._v("Workshop")]),
      _vm._v(" "),
      _c("span", { staticClass: "stat permanent" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("a", { attrs: { href: "" } }, [
        _vm._v("Sample video title to test long video names")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "before" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "after" }, [_c("span")])
  }
]
render._withStripped = true

export { render, staticRenderFns }